/**
 * E2E Bypass — ALTCHA captcha bypass voor geautomatiseerde tests.
 *
 * Wanneer de query parameter `_e2e=BREUER_E2E_2024` aanwezig is,
 * wordt de ALTCHA captcha overgeslagen. Dit maakt het mogelijk om
 * form submission te testen in Playwright E2E tests.
 *
 * Gebruik: /offerte?_e2e=BREUER_E2E_2024
 */

export const E2E_BYPASS_KEY = '_e2e';
export const E2E_BYPASS_VALUE = 'BREUER_E2E_2024';
export const E2E_BYPASS_TOKEN = 'E2E_BYPASS_DUMMY_TOKEN';

/** Check of de bypass actief is op basis van een query parameter waarde */
export function isE2EBypass(paramValue: string | null): boolean {
	return paramValue === E2E_BYPASS_VALUE;
}
